import { OnboardingKeys } from './onboarding-state/onboarding-constants';
import { ContextualInviteNudgeOnboardingKeys } from './onboarding-state/onboarding-contextual-invite-nudge';
import { EditorOnboardingKeys } from './onboarding-state/onboarding-editor-constants';
import { EnhanceOrientationOnboardingKeys } from './onboarding-state/onboarding-enhance-orientation-constants';
import { FeedOnboardingKeys } from './onboarding-state/onboarding-feed-constants';
import { HomeTakeoverOnboardingKeys } from './onboarding-state/onboarding-home-takeover-constants';
import { InsightsOnboardingKeys } from './onboarding-state/onboarding-insights-constants';
import { LandInSpampleSpaceOnboardingKeys } from './onboarding-state/onboarding-land-in-sample-space';
import { LiveDocsOnboardingKeys } from './onboarding-state/onboarding-live-docs-constants';
import { SpaceMissionControlOnboardingKeys } from './onboarding-state/onboarding-mission-control-constants';
import { PersonalizedTemplatesOnboardingKeys } from './onboarding-state/onboarding-personalized-templates-constants';
import { PresenceAdminFeedbackSurveyOnboardingKeys } from './onboarding-state/onboarding-presence-admin-feedback-survey';
import { PresencePageOnboardingKeys } from './onboarding-state/onboarding-presence-page-constants';
import { QuickstartOnboardingKeys } from './onboarding-state/onboarding-quickstart-constants';
import { RoleBasedAccessControlOnboardingKeys } from './onboarding-state/onboarding-role-based-access-control';
import { RovoVideoPlayerStateOnboardingKeys } from './onboarding-state/onboarding-rovo-video-player-constants';
import { ShareAndRestrictDialogOnboardingKeys } from './onboarding-state/onboarding-share-and-restrict-dialog-constants';
import { StorageEnforcementOnboardingKeys } from './onboarding-state/storage-enforcement/storage-enforcement-constants';
import { TrialComponentsOnboardingKeys } from './trial-components/trial-components-constants';
import { CreateIntroFirstStepOnboardingStateKeys } from './onboarding-state/onboarding-create-intro-first-step-constants';
import { ExperimentPromptWhiteboardTemplatesOnboardingKeys } from './onboarding-state/experiment-prompt-whiteboard-templates-constants';
import { NotesOnboardingSpotlightKeys } from './onboarding-state/onboarding-notes-constants';
import { AIFCOnboardingKeys } from './onboarding-state/onboarding-afic-onboarding';

export const OnboardingKeysCombined = [
	...StorageEnforcementOnboardingKeys,
	...OnboardingKeys,
	...ContextualInviteNudgeOnboardingKeys,
	...EditorOnboardingKeys,
	...InsightsOnboardingKeys,
	...SpaceMissionControlOnboardingKeys,
	...PresenceAdminFeedbackSurveyOnboardingKeys,
	...PresencePageOnboardingKeys,
	...QuickstartOnboardingKeys,
	...RoleBasedAccessControlOnboardingKeys,
	...RovoVideoPlayerStateOnboardingKeys,
	...ShareAndRestrictDialogOnboardingKeys,
	...TrialComponentsOnboardingKeys,
	...PersonalizedTemplatesOnboardingKeys,
	...LiveDocsOnboardingKeys,
	...HomeTakeoverOnboardingKeys,
	...FeedOnboardingKeys,
	...EnhanceOrientationOnboardingKeys,
	...LandInSpampleSpaceOnboardingKeys,
	...CreateIntroFirstStepOnboardingStateKeys,
	...ExperimentPromptWhiteboardTemplatesOnboardingKeys,
	...NotesOnboardingSpotlightKeys,
	...AIFCOnboardingKeys,
] as const;

export type OnboardingKeysCombinedType = (typeof OnboardingKeysCombined)[number];
